export default "__VITE_ASSET__CUa_9k6y__"